import type { Question } from '../types';

export const QUESTIONS: Question[] = [
  {
    id: 'nombre',
    number: 1,
    type: 'text-short',
    question: '¿Cuál es tu nombre completo?',
    placeholder: 'Nombre',
    required: true,
  },
  {
    id: 'email',
    number: 2,
    type: 'email',
    question: '¿Cuál es tu Correo electrónico?',
    placeholder: 'ejemplo@ejemplo.com',
    required: true,
  },
  {
    id: 'whatsapp',
    number: 3,
    type: 'phone-intl',
    question: '¿Cuál es tu número de WhatsApp?',
    helper: 'Detectamos tu país automáticamente. Solo escribe tu número.',
    required: true,
  },
  {
    id: 'instagram',
    number: 4,
    type: 'text-short',
    question: '¿Cuál es tu Instagram?',
    helper: "Si no tienes Instagram, escribe 'NO TENGO'",
    required: true,
  },
  {
    id: 'modelo_negocio',
    number: 5,
    type: 'text-long',
    question: 'Describe de forma clara y objetiva tu modelo de negocio actual.',
    minLength: 40,
    maxLength: 120,
    required: true,
  },
  {
    id: 'mayor_reto',
    number: 6,
    type: 'text-long',
    question: '¿Cuál es tu mayor reto actualmente y el motivo de entrar a HIT?',
    minLength: 40,
    maxLength: 120,
    required: true,
  },
  {
    id: 'tiempo_conoce_javi',
    number: 7,
    type: 'single-choice',
    question: '¿Desde hace cuánto conoces a Javi?',
    options: [
      'Hace 1 semana',
      'Hace 1 mes',
      'Entre 2 y 3 meses',
      'Entre 4 y 6 meses',
      'Entre 7 y 11 meses',
      'Más de 1 año',
    ],
    required: true,
  },
  {
    id: 'facturacion_2026',
    number: 8,
    type: 'single-choice',
    question: '¿Cuánto es tu facturación Mensual en el 2026?',
    helper: 'Para entenderlo mejor 1k=1.000 dólares',
    options: [
      '1K$/menos',
      '1K a 5K',
      '5K a 10K',
      '10K a 20K',
      '20K A 50K',
      '50K a 100K',
      'Más de 100K',
    ],
    required: true,
  },
  {
    id: 'inversion_historial',
    number: 9,
    type: 'single-choice',
    question:
      '¿Has invertido antes en formaciones, mentorías o agencias de marketing, ventas o publicidad para tu negocio?',
    options: [
      'Sí, he invertido en varias formaciones, mentorías o agencias y he obtenido resultados sólidos.',
      'Sí, he invertido en algunas, pero los resultados no fueron los que esperaba.',
      'Sí, invertí una vez y no me funcionó como esperaba. No he vuelto a invertir desde entonces.',
      'No, todavía no he invertido en formaciones ni estrategias pagadas. Ha sido todo aprendizaje autodidacta.',
      'Estoy considerando invertir por primera vez y esta podría ser mi primera decisión.',
    ],
    required: true,
  },
  {
    id: 'inversion_monto',
    number: 10,
    type: 'single-choice',
    question:
      'Si has invertido antes, ¿cuál es el rango aproximado que has invertido en total en formación y estrategias para tu negocio hasta hoy?',
    options: [
      'Menos de 500 USD',
      'Entre 500 y 2.000 USD',
      'Entre 2.000 y 5.000 USD',
      'Entre 5.000 y 10.000 USD',
      'Más de 10.000 USD',
      'No he invertido aún',
    ],
    required: true,
  },
  {
    id: 'negocio_estructura',
    number: 11,
    type: 'single-choice',
    question:
      '¿Cómo se estructura hoy tu negocio en cuanto a eventos y modalidad de trabajo con tu comunidad y clientes?',
    options: [
      'Realizo eventos presenciales y online de forma activa. Combino masterclasses, retiros, talleres o eventos masivos con mis programas digitales.',
      'Realizo eventos online masivos (masterclasses en vivo, retos, cumbres o lanzamientos digitales) y quiero empezar a integrar el mundo presencial.',
      'Realizo eventos presenciales (talleres, seminarios, retiros o encuentros grupales) y quiero llevar mi negocio también al mundo digital con eventos online.',
      'Todavía no hago eventos. Mi negocio se basa en sesiones individuales o grupos cerrados de trabajo continuo, sin eventos que llenan audiencia.',
      'Estoy comenzando a estructurar mi negocio y aún no he hecho ni eventos presenciales, ni online.',
    ],
    required: true,
  },
  {
    id: 'por_que_seleccionarte',
    number: 12,
    type: 'text-long',
    question:
      'Recibimos +10 aplicaciones por día para entrar a HIT. ¿Por qué crees que deberíamos seleccionarte a ti?',
    minLength: 40,
    maxLength: 120,
    required: true,
  },
  {
    id: 'compromiso',
    number: 13,
    type: 'single-choice',
    question:
      '¿Te comprometes a asistir a tiempo y sin distracciones a la sesión? Solo trabajamos con personas serias y comprometidas. (Esto es muy importante porque vamos a reservarnos un espacio exclusivo 1-a-1 para ti).',
    options: ['Me comprometo a asistir', 'No asistiré y dejaré esperando a mi asesor'],
    required: true,
  },
];
